export default "module.exports = (async () => {\n  return await channel.send('hello!');\n})();"